module.exports = __webpack_public_path__ + "img/fleche-bas.1f431c8d.png";